"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import { DropdownMenu, DropdownMenuButton, DropdownMenuItem, DropdownMenuList, } from "../../atoms";
const DropdownItem = ({ dropDownMenuProps, dropDownMenuButtonProps, dropDownIconVisible, titleVisible, items, }) => (_jsx(DropdownMenu, Object.assign({ autoSelect: false }, dropDownMenuProps, { children: ({ isOpen }) => (_jsxs(_Fragment, { children: [_jsx(DropdownMenuButton, Object.assign({}, dropDownMenuButtonProps, { 
                // Overwrite props from what user can specify in SideMenu
                dropDownIconVisible: dropDownIconVisible, titleVisible: titleVisible, isOpen: isOpen })), _jsx(DropdownMenuList, { children: items.map((item) => {
                    // Remove icon from props
                    const { icon } = item, itemProps = __rest(item, ["icon"]);
                    return (_jsx(DropdownMenuItem, Object.assign({ icon: _jsx(Box, { children: icon }) }, itemProps), item.title));
                }) })] })) })));
DropdownItem.displayName = "DropdownItem";
export default DropdownItem;
//# sourceMappingURL=DropdownItem.js.map